import { render, staticRenderFns } from "./SupportChatHead.vue?vue&type=template&id=e3ed8e30&"
import script from "./SupportChatHead.vue?vue&type=script&lang=ts&"
export * from "./SupportChatHead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports